import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorOutline } from '@mui/icons-material';
import { Button } from '@mui/material';
import cn from 'classnames';

import { IErrorProps } from './Error.interface';

import './styles.scss';

export const Error: FC<IErrorProps> = ({ className, message, onRetry }) => {
  const { t } = useTranslation();

  return (
    <div className={cn('error', className)}>
      <ErrorOutline className="error__icon" color="error" />

      <div className="error__message">{message}</div>

      {onRetry && (
        <Button className="error__button" variant="text" color="secondary" onClick={onRetry}>
          {t('common.retry')}
        </Button>
      )}
    </div>
  );
};

export default Error;
